<template>
  <div class="app">
    <app-header />
    <div class="app-content"
      :class="{
        'app-content-white': whiteBackground
      }">
      <router-view />
    </div>
    <app-footer />
  </div>
</template>

<script>
import AppHeader from '@/components/App/AppHeader'
import AppFooter from '@/components/App/AppFooter'

export default {
  name: 'app',
  components: {
    AppHeader,
    AppFooter
  },

  data() {
    return {
      whiteBackground: false
    }
  },

  mounted() {
    this.hasWhiteBackground()
  },

  watch: {
    $route: function() {
      this.hasWhiteBackground()
    }
  },

  methods: {
    hasWhiteBackground() {
      const pages = [
        '/',
        '/arbetsgivarinformation',
        '/kontakta-oss',
        '/om-jobskills'
      ]

      this.whiteBackground = pages.includes(window.location.pathname)
    }
  }
}
</script>

<style lang="postcss">
@import 'variables/custom-media.css';
html,
body {
  background-color: var(--color-porcelain);
  color: var(--color-mine-shaft);
  font-family: var(--font-default);
  height: 100%;
  margin: 0;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    background-color: var(--color-pickled-bluewood);
  }
}

:global(.rtl) {
  direction: rtl;
}

:global(.ltr) {
  direction: ltr;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;

  & li {
    font-size: 16px;
    line-height: 24px;

    @media (--bp-nis-medium) {
      font-size: 18px;
      line-height: 27px;
    }
  }
}

* {
  box-sizing: border-box;
}

img {
  max-width: 100%;
}

a {
  font-size: 16px;
  font-weight: 400;
  color: var(--color-shakespeare);
  text-decoration: none;

  &:visited,
  &:hover,
  &:focus {
    color: var(--color-shakespeare);
    text-decoration: underline;
  }

  @media (--bp-nis-medium) {
    font-size: 18px;
    line-height: 27px;
  }
}

p {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;

  @media (--bp-nis-medium) {
    font-size: 18px;
    line-height: 27px;
  }
}

/*
// General
// ------------------------------------------------*/

.app {
  display: flex;
  flex-direction: column;

  @supports (display: grid) {
    display: grid;
    grid-template-areas: 'header' 'navigation' 'content' 'footer';
    grid-template-columns: 1fr;
    grid-template-rows: auto auto 1fr auto;
    height: 100vh;
  }

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    display: -ms-grid;
    -ms-grid-columns: 1fr;
    -ms-grid-rows: auto 1fr auto;
  }
}

/*
// Content
// ------------------------------------------------*/

.app-content {
  background: var(--color-alabaster);

  @supports (display: grid) {
    grid-area: content;
  }

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    -ms-grid-column: 1;
    -ms-grid-row: 2;
  }

  @supports (-ms-ime-align: auto) {
    -ms-grid-column: 1;
    -ms-grid-row: 2;
  }
}

.app-content-white {
  background: var(--color-white);
}
</style>



// WEBPACK FOOTER //
// src/App.vue